import { useNavigate, useParams } from 'react-router-dom'
import { useEffect } from 'react'
import { usePostReferralClickMutation } from '../../app/api'
import { useCookies } from 'react-cookie'

export const ReferralCodePage = () => {
  const { id } = useParams()
  const [cookies, setCookie] = useCookies(['ref_cookie_id'])
  const navigate = useNavigate()

  const [getClick] = usePostReferralClickMutation()

  useEffect(() => {
    if (id) {
      getClick({
        code: id,
        ...(cookies.ref_cookie_id && { refCookieId: cookies.ref_cookie_id }),
      })
        .unwrap()
        .then((response) => {
          if (response.success && response.data?.cookie_id) {
            setCookie('ref_cookie_id', response.data.cookie_id, {
              path: '/',
              maxAge: 30 * 24 * 60 * 60,
            })
          }
        })
        .catch(() => undefined)
        .finally(() => setTimeout(() => navigate('/auth/signup'), 500))
    } else {
      navigate('/auth/signup')
    }
  }, [])

  return null
}
